export const MAX_YEAR = 130

/** The `MM/DD/YYYY` the birth date input produces once every part is typed. */
export const BIRTH_DATE_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/

export const PROFILE_FIRST_NAME_VALIDATION = {
  required: 'Please, enter First Name',
  maxLength: 'First Name must be shorter or equal to 80 characters',
} as const

export const PROFILE_LAST_NAME_VALIDATION = {
  maxLength: 'Last Name must be shorter or equal to 80 characters',
} as const

export const PROFILE_BIRTHDAY_VALIDATION = {
  birthDate: 'Please enter a valid date of birth in the format MM/DD/YYYY',
  isDatePassed: 'The date must be in the past',
} as const

export function getProfileBirthdayIsDateTooOldMessage(): string {
  return `Please enter a year after ${new Date().getFullYear() - MAX_YEAR}`
}

export function getProfileBirthdayValidationMessages() {
  return {
    ...PROFILE_BIRTHDAY_VALIDATION,
    isDateTooOld: getProfileBirthdayIsDateTooOldMessage(),
  }
}
